import { SVGProps } from 'react'

import { CSS } from '@stitches/react'
import { CSSProps, styled } from 'style'

import Box from 'components/atomic/atoms/box'
import { RadixIcon } from 'components/atomic/atoms/icon'
import Text from 'components/atomic/atoms/text'

import { FCC } from 'types/react'

const CardStyled = styled(Box, {
  border: '1px solid $bg3',
  borderRadius: '$lg',

  variants: {
    bgc: {
      1: {
        bgc: '$bg1',
      },
      2: {
        bgc: '$bg2',
      },
      3: {
        bgc: '$bgCard',
      },
    },
    disabled: {
      true: {
        '& *': {
          cursor: 'not-allowed',
        },
      },
    },
  },
  defaultVariants: {
    bgc: '$bg1',
  },
})

const CardHeaderStyled = styled(Box, {
  borderBottom: '1px solid $bg3',
  px: '$3',
  py: '$2-5',
  '@md': { px: '$5', py: '$4' },
})

const CardBodyStyled = styled(Box, {
  p: '$3',
  '@md': { p: '$5' },
})

const CardFooterStyled = styled(Box, {
  borderTop: '1px solid $bg3',
  textAlign: 'right',
  px: '$3',
  py: '$2-5',
  '@md': { px: '$5', py: '$4' },
})

export const Root = CardStyled
export const Header = CardHeaderStyled

export const Icon = (props: {
  icon: RadixIcon | ((props: SVGProps<SVGSVGElement>) => JSX.Element)
  css?: CSS
}) => <Text as={props.icon} color="text1" css={{ ...props.css, size: 20 }} />

export const Title: FCC<CSSProps> = ({ children, css }) => (
  <Text as="h2" size="xl" weight="bold" css={css}>
    {children}
  </Text>
)

export const Body = CardBodyStyled
export const Footer = CardFooterStyled
